import { useEffect, useState } from "react";
import { Flex, Spin, Collapse, Empty } from "antd";

import IdentificationIcon from "@/icons/IdentificationIcon";
import PaperAirplaneIcon from "@/icons/PaperAirplaneIcon";
import DeviceTabletIcon from "@/icons/DeviceTabletIcon";

import Widget from "@/components/ui/Widget";
import SearchFrom3 from "@/components/inputs/SearchFrom3";
import EmployeeProfile from "@/components/cards/EmployeeProfile";

import { getContacts } from "@/api/widgets";

const ContactsWidget = () => {
  const [data, setData] = useState([]);
  const [pending, setPending] = useState(true);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const fetchData = async (search = "") => {
    setPending(true);

    try {
      const data = await getContacts(search);
      setData(formatData(data));
    } catch (error) {
      console.log("error", error);
    } finally {
      setPending(false);
    }
  };

  const formatData = (data) => {
    return data
      .sort((a, b) => {
        const aFullName = `${a.lastname} ${a.firstname} ${a.patronymic}`;
        const bFullName = `${b.lastname} ${b.firstname} ${b.patronymic}`;
        return aFullName.localeCompare(bFullName);
      })
      .map((contact) => {
        return {
          key: contact.uuid,
          label: (
            <div className="contact-item-header">
              <EmployeeProfile {...contact} avatarSize={18} align="start" />
            </div>
          ),
          children: (
            <Flex vertical gap={1} style={{ color: "#777777" }}>
              <Flex align="start" gap={6}>
                <IdentificationIcon style={{ fontSize: 18, color: "#BBB" }} />
                {contact.position_name || "-"}
              </Flex>
              <Flex align="center" gap={6}>
                <PaperAirplaneIcon style={{ fontSize: 18, color: "#BBB" }} />
                {contact.secondary_email || "-"}
              </Flex>
              <Flex align="center" gap={6}>
                <DeviceTabletIcon style={{ fontSize: 18, color: "#BBB" }} />
                {contact.phone || "-"}
              </Flex>
            </Flex>
          ),
          showArrow: false,
          className: "contact-item",
        };
      });
  };

  return (
    <Widget
      value="contacts"
      label="Контакты"
      labelSecond={data.length}
      isOpen={true}
    >
      <Flex vertical gap={4} className="h-100">
        <SearchFrom3
          placeholder="Начните вводить"
          onSearch={(search) => {
            if (!search) {
              fetchData();
              return;
            }
            if (search?.length > 2) {
              fetchData(search);
              return;
            }
          }}
        />

        {pending ? (
          <div className="spin">
            <Spin size="large" />
          </div>
        ) : (
          <>
            {!data?.length ? (
              <Empty
                image={false}
                description="Нет контактов"
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            ) : (
              <Collapse
                items={data}
                bordered={false}
                className="contacts-collapse"
              />
            )}
          </>
        )}
      </Flex>
    </Widget>
  );
};

export default ContactsWidget;
